import OverviewVM from './overview-vm';

export default {
  init(node) {
    if (node != undefined){
      const courseId = node.dataset.courseId;
      const courseworkId = node.dataset.courseworkId;
      const layoutMode = node.dataset.layoutMode;
      const browsingScope = node.dataset.browsingScope;
      const userType = node.dataset.userType;

      const vm = new OverviewVM(
        courseId,
        courseworkId,
        layoutMode,
        browsingScope,
        userType
      );

      ko.applyBindings(vm, node);
    };
  }
};

